export default __webpack_public_path__ + "static/media/child_smile.cedab5ee.jpg";